import {Component, inject} from '@angular/core';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';

@Component({
  selector: 'app-close-button',
  imports: [],
  templateUrl: './close-button.component.html',
  styleUrl: './close-button.component.css'
})
export class CloseButtonComponent {

  private mainViewStore = inject(MainViewStore);

  constructor() {}

  close() {
    this.mainViewStore.hideChildComponent();
  }
}
